/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Use the season selector to switch years and compare how drivers and constructors finished in past championships. Historical standings help you spot which teams tend to develop strongly through a season and which fade, which is useful context when planning fantasy transfers.`)
};

const es_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Usa el selector de temporada para cambiar de año y comparar cómo terminaron pilotos y constructores en campeonatos pasados. Las clasificaciones históricas te ayudan a detectar qué equipos suelen desarrollarse con fuerza a lo largo de una temporada y cuáles se desvanecen, lo cual es un contexto útil al planificar tus fichajes de fantasy.`)
};

const de_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Nutze die Saisonauswahl, um zwischen Jahren zu wechseln und zu vergleichen, wie Fahrer und Konstrukteure in vergangenen Meisterschaften abgeschnitten haben. Historische Tabellen helfen dir zu erkennen, welche Teams sich im Saisonverlauf typischerweise stark entwickeln und welche nachlassen — nützlicher Kontext bei der Planung von Fantasy-Transfers.`)
};

const nl_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Gebruik de seizoenselector om van jaar te wisselen en te vergelijken hoe coureurs en constructeurs eindigden in eerdere kampioenschappen. Historische standen helpen je te zien welke teams doorgaans sterk ontwikkelen gedurende een seizoen en welke wegzakken — nuttige context bij het plannen van fantasy-transfers.`)
};

const fr_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Utilisez le sélecteur de saison pour changer d'année et comparer comment pilotes et constructeurs ont terminé les championnats passés. Les classements historiques vous aident à repérer quelles équipes ont tendance à bien se développer au fil d'une saison et lesquelles s'essoufflent — un contexte utile pour planifier vos transferts fantasy.`)
};

const it_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Usa il selettore di stagione per cambiare anno e confrontare come piloti e costruttori si sono classificati nei campionati passati. Le classifiche storiche ti aiutano a individuare quali team tendono a svilupparsi con forza nel corso di una stagione e quali invece calano, un contesto utile quando pianifichi i trasferimenti fantasy.`)
};

const pt_br2_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Use o seletor de temporada para mudar de ano e comparar como pilotos e construtores terminaram em campeonatos passados. As classificações históricas ajudam você a identificar quais times costumam se desenvolver fortemente ao longo de uma temporada e quais perdem força, um contexto útil ao planejar suas trocas no fantasy.`)
};

const pt_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Use o seletor de época para mudar de ano e comparar como pilotos e construtores terminaram em campeonatos passados. As classificações históricas ajudam-no a identificar quais as equipas que tendem a desenvolver-se fortemente ao longo de uma época e quais tendem a esmorecer, um contexto útil ao planear as suas transferências fantasy.`)
};

const ja_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。シーズンセレクターを使って年を切り替え、過去の選手権でドライバーとコンストラクターがどう終えたかを比較できます。過去の順位表を見ることで、シーズンを通して強く成長する傾向にあるチームと、失速する傾向にあるチームを見分けられます。これはファンタジーの移籍を計画する際に役立つ情報です。`)
};

const zh_f1_st_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。使用赛季选择器切换年份,比较车手和车队在过往锦标赛中的最终排名。历史积分榜能帮你发现哪些车队在赛季中往往会强势成长,哪些会逐渐掉队——这在规划梦幻转会时是很有用的参考。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_st_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_st_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_st_faq3_a", locale)
	if (locale === "en") return en_f1_st_faq3_a(inputs)
	if (locale === "es") return es_f1_st_faq3_a(inputs)
	if (locale === "de") return de_f1_st_faq3_a(inputs)
	if (locale === "nl") return nl_f1_st_faq3_a(inputs)
	if (locale === "fr") return fr_f1_st_faq3_a(inputs)
	if (locale === "it") return it_f1_st_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_st_faq3_a(inputs)
	if (locale === "pt") return pt_f1_st_faq3_a(inputs)
	if (locale === "ja") return ja_f1_st_faq3_a(inputs)
	return zh_f1_st_faq3_a(inputs)
};